export const APP_NAME = "S-HUMAN HEALTHCARE";
